import { legacy, bffUpload } from '@/shared/api/client';
import type { PassbookTier } from '@/shared/types';

export interface TierSettingsPayload {
  tiers?: PassbookTier[];
  hasTiers?: boolean;
  barcodeFormat?: 'QR' | 'CODE128';
  hasConfig?: boolean;
}

/** Persiste tiers/barcodeFormat no passbook (PUT /passbook/:id/tiers). */
export async function updateTierSettings(
  idPassbook: string,
  payload: TierSettingsPayload,
): Promise<void> {
  await legacy.put<{ ok: boolean }>(`/passbook/${idPassbook}/tiers`, payload, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
}

/**
 * Envia uma imagem (strip ou logo) de um tier. O nome do arquivo é quem
 * define qual tier — e qual asset — a imagem representa no legado — ver
 * api/controllers/generate.js (setStripImage/getStripImageGoogleWallet para
 * strip; pass.images.logo/createPassClass para logo) — por isso o filename é
 * forçado aqui, mesmo que o arquivo original tenha outro nome, e precisa
 * terminar em .png (é o que generate.js/callback.js montam na URL).
 *
 * O logo manda o MESMO arquivo duas vezes — como `logo_<tier>.png` (Apple, e
 * fallback do Google se não tiver @2x) e `logo_<tier>@2x.png` (usado como
 * logo do Google Wallet, que não tem conceito de @1x/@2x e prefere a
 * resolução maior) — um clique só, sem precisar de um terceiro arquivo
 * `gwallet_<tier>.png` (quase sempre seria a mesma imagem mesmo).
 */
export async function uploadTierImage(
  idPassbook: string,
  tierLevel: string,
  file: File,
  kind: 'strip' | 'logo' = 'strip',
): Promise<void> {
  const formData = new FormData();
  formData.append('passbook_id', idPassbook);
  if (kind === 'logo') {
    formData.append('logo', file, `logo_${tierLevel}.png`);
    formData.append('logo2x', file, `logo_${tierLevel}@2x.png`);
  } else {
    formData.append('strip', file, `strip_${tierLevel}.png`);
  }
  await bffUpload(`/bff/uploads/passbook/${idPassbook}/tier-image`, formData);
}
